import { Numeric } from '@/lib/types/common';
import { capNumber } from '@/lib/utils/capNumber';

type CapNumberParams = {
  value: Numeric;
  min?: Numeric;
  max?: Numeric;
};

export function isNumberWithinBounds({ value, min, max }: CapNumberParams) {
  return capNumber({ value, min, max }).eq(value);
}
